<script setup lang="ts">
import type {BenefitItem} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import Heading from '../ui/heading.vue'

const props = defineProps<{
  data: Populated<BenefitItem>
}>()
</script>

<template>
  <div
    class="group w-[300px] space-y-8 rounded-lg border bg-white p-6 shadow-md transition-all duration-300 ease-in-out hover:border-main-500 hover:bg-main-50"
  >
    <div class="mb-2 inline-flex h-16 w-16 items-center justify-center rounded-full bg-main-50">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-main-100 text-main-700 transition-all duration-300 ease-in-out group-hover:bg-main-500 group-hover:text-white"
      >
        <Icon class="h-6 w-6" :name="props.data.icon!" />
      </div>
    </div>
    <div class="space-y-4">
      <Heading class="mb-4" as="h3" size="small">{{ props.data.title }}</Heading>
      <Paragraph v-if="props.data.description"> {{ props.data.description }}</Paragraph>
      <RichText v-if="data.richDescription" :raw="data.richDescription" />
    </div>
  </div>
</template>
